'use client';
import Link from 'next/link';
import Script from 'next/script';
import React from 'react';

import { cn } from '@/lib/utils';

import { useTrustpilotRef } from '@/integrations/trustpilot/utils';
import { useTheme } from '@/theme/ThemeProvider';

interface TrustpilotBadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  classNames?: {
    root: string;
  };
}

const TRUSTPILOT_SCRIPT_ID = 'trustpilot-widget-script';

export const TrustpilotBadge = ({ classNames }: TrustpilotBadgeProps) => {
  const themeContext = useTheme();
  const widgetRef = useTrustpilotRef();
  return (
    <>
      <Script
        strategy='lazyOnload'
        id={TRUSTPILOT_SCRIPT_ID}
        type='text/javascript'
        src='//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'
        async
      />

      <div
        ref={widgetRef}
        className={cn(
          'trustpilot-widget',
          'h-10 w-[90px] overflow-hidden',
          classNames?.root
        )}
        data-tracker-component='trustpilot-badge'
        data-locale='en-US'
        data-template-id='53aa8807dec7e10d38f59f32'
        data-businessunit-id='67f91a41d68b154e79a253a4'
        data-style-height='150px'
        data-style-width='100%'
        data-theme={themeContext.theme}
        data-token='4c92f2f1-8f99-4861-84cf-2d9e1ae1ac8d'
      >
        <Link
          data-tracker-type='link'
          href='https://www.trustpilot.com/review/decodo.com'
          target='_blank'
          rel='noopener'
        ></Link>
      </div>
    </>
  );
};
